module.exports = __webpack_public_path__ + "static/img/aboutUs09.cfad8c0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/aboutUs/aboutUs09.jpg
// module id = 1361
// module chunks = 1